import { EmptyContent } from '@/components/ui';
import { IconLockAccess } from '@tabler/icons-react';

export function DashboardNoAccess() {
  return (
    <EmptyContent
      withIconBox
      state="error"
      icon={<IconLockAccess />}
      title="No access"
      description="You do not have access to any section.
      Please contact your administrator."
    />
  );
}
